<ng-lottie
  [width]="width"
  [height]="height"
  [options]="options"
  (animationCreated)="animationCreatedHandler($event)"
  (enterFrame)="enterFrame($event)"
></ng-lottie>
